import { render, staticRenderFns } from "./PropertyWizard.vue?vue&type=template&id=4bf24573&scoped=true&"
import script from "./PropertyWizard.vue?vue&type=script&lang=js&"
export * from "./PropertyWizard.vue?vue&type=script&lang=js&"
import style0 from "./PropertyWizard.vue?vue&type=style&index=0&id=4bf24573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf24573",
  null
  
)

export default component.exports